import * as yup from "yup";
import { selectOptionSchema } from "forms/schemas";

export const requestOrderSchema = (
  minDate = new Date(),
  maxDate = new Date()
) =>
  yup.object().shape({
    shipFrom: selectOptionSchema.required("Ship From is required").nullable(),
    mode: selectOptionSchema.required("Mode is required").nullable(),
    salesTerms: selectOptionSchema
      .required("Sales Terms is required")
      .nullable(),
    shipTo: selectOptionSchema.required("Ship To is required").nullable(),
    quantityPerOrder: yup.number().required("required field"),
    requestedShipDate: yup
      .date()
      .required("Requested Ship Date is required")
      .min(
        minDate,
        "Requested Ship Date must be after Contract Start Ship Date"
      )
      .max(maxDate, "Requested Ship Date must be before Contract End Ship Date")
      .optional(),
    poNumber: yup
      .string()
      .optional()
      .test(
        "under 20 PO numbers",
        "The limit is 20 orders per request",
        function (value) {
          const poCount = value?.split(",").length ?? 0;
          return poCount <= 20;
        }
      )
      .test(
        "to long PO number(s)",
        "Each PO is limited to 100 characters or less",
        function (value) {
          return value?.split(",").every((value) => value.length <= 100);
        }
      )
      .test(
        "match",
        "Number of POs in the request does not match the number of requested orders. Please adjust and try again.",
        function (value) {
          const poCount = value?.split(",").length ?? 0;
          const orderCount = this.parent.numberOfOrders;
          return poCount <= orderCount;
        }
      ),
    numberOfOrders: yup
      .number()
      .required("No. of Orders is a required field")
      .min(1, "At least 1 order is required")
      .max(20, "20 orders per request is the limit"),
  });
